import React, { Component } from 'react'
import Button from './Button'
import styles from './BigButtonDisabled.css'

const BigButtonDisbaled = props => <Button className={styles.bigbutton} {...props} />

export default BigButtonDisbaled
